const ChangePassword = () => {
  return (
    <div className="p-4 bg-white rounded-md">
      <h2 className="text-xl text-slate-600 pb-5">Cambiar Contraseña </h2>

      <form>
        <div className="flex flex-col gap-1 mb-2">
          <label htmlFor="old_password">Contraseña actual</label>
          <input
            className="outline-none px-3 py-1 border rounded-md text-slate-600 w-full sm:w-6/12"
            type="password"
            name="old_password"
            id="old_password"
            placeholder="Contraseña actual"
          />
        </div>

        <div className="flex flex-col gap-1 mb-2">
          <label htmlFor="new_password">Contraseña nueva</label>
          <input
            className="outline-none px-3 py-1 border rounded-md text-slate-600 w-full sm:w-6/12"
            type="password"
            name="new_password"
            id="new_password"
            placeholder="Contraseña nueva"
          />
        </div>

        <div className="flex flex-col gap-1 mb-2">
          <label htmlFor="confirm_password">Confirmar Contraseña</label>
          <input
            className="outline-none px-3 py-1 border rounded-md text-slate-600 w-full sm:w-6/12"
            type="password"
            name="confirm_password"
            id="confirm_password"
            placeholder="Confirmar Contraseña"
          />
        </div>
        <div>
          <button className="px-8 py-2 bg-[#059473] shadow-lg hover:shadow-green-500/30 text-white rounded-md">
            Actualizar Contraseña
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
